import { useQuery, useMutation, UseQueryOptions, UseMutationOptions, QueryKey } from '@tanstack/react-query';
import { AxiosResponse, AxiosError } from 'axios';

export const SILOREAL_SERVICE_META_SOURCE = 'useSiloRealService';

const SILOREAL_SERVICE_META = {
  source: SILOREAL_SERVICE_META_SOURCE,
  toastOnError: true,
};

function useSiloRealServiceQuery<
  TData = unknown,
  TError = AxiosError,
  TQueryFnData = AxiosResponse<TData>,
  TQueryKey extends QueryKey = QueryKey,
>(
  service: () => Promise<TQueryFnData>,
  config: Omit<UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>, 'queryFn'>
) {
  return useQuery<TQueryFnData, TError, TData, TQueryKey>({
    ...config,
    meta: {
      ...(config.meta ?? {}),
      ...SILOREAL_SERVICE_META,
    },
    queryFn: service,
  });
}

function useSiloRealServiceMutation<
  TData = unknown,
  TError = AxiosError,
  TVariables = void,
  TContext = unknown,
>(
  service: (variables: TVariables) => Promise<TData>,
  config?: Omit<UseMutationOptions<TData, TError, TVariables, TContext>, 'mutationFn'>
) {
  return useMutation<TData, TError, TVariables, TContext>({
    ...config,
    meta: {
      ...(config?.meta ?? {}),
      ...SILOREAL_SERVICE_META,
    },
    mutationFn: service,
  });
}

export const useSiloRealService = {
  query: useSiloRealServiceQuery,
  mutation: useSiloRealServiceMutation,
};
